import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import "./Addr.css";

const Addr = () => {
  const { t } = useTranslation();

  return (
    <div className="card-container-addr">
        <div className="card-addr">
          <h4 className="add-head">{t("Regional office 1")}</h4>
          <ul>
            <li id="addr">
              <Link target="_blank" to={`https://www.google.com/maps/place/M+Squared+Training+Center/@8.5610138,76.877269,21z/data=!4m6!3m5!1s0x3b05bfbac7e547cb:0x7d8dd342944e8cc1!8m2!3d8.5610546!4d76.8771098!16s%2Fg%2F11ksntzjtt?entry=ttu`}>
                <span className="list-text">
                  {t("M Squared Training Center, ")}
                  <br /> {t("M Squared Building, Technopark Campus")}
                  <br />
                  {t("Thiruvananthapuram – 695581 Kerala, India ")}{" "}
                </span>
              </Link>
            </li>
            <li id="mail">
              <Link to={`/`}>
                <span className="list-text">m2info@m2comsys.us</span>
              </Link>
            </li>
            <li id="phone">
              <Link to={`/`}>
                <span className="list-text">
                  +91 8113869999, 0471 4084000
                </span>
              </Link>
            </li>
          </ul>
        </div>
        <div className="card-addr">
          <h4 className="add-head">{t("Regional office 2")}</h4>
          <ul>
            <li id="addr">
              <Link target="_blank" to={`https://www.google.com/maps/place/M-+Squared+Training+Center,+Kochi/@9.9923567,76.2975532,17z/data=!3m1!4b1!4m6!3m5!1s0x3b080d87492d9853:0x3963192086b50ab3!8m2!3d9.9923515!4d76.3024241!16s%2Fg%2F11l1jrffbs?entry=ttu`}>
                <span className="list-text">
                  M Squared Training Center,
                  <br />
                  2nd Floor, Thattamveedu Building, <br />
                  South Janatha Cross Road, Behind JLN Stadium, <br />
                  Kochi 682025 Kerala, India
                </span>
              </Link>
            </li>
            <li id="mail">
              <Link to={`/`}>
              <span className="list-text">m2info@m2comsys.us</span>
              </Link>
            </li>
            <li id="phone">
              <Link to={`/`}>
                <span className="list-text">+91-7907303904 </span>
              </Link>
            </li>
          </ul>
        </div>
        {/* <div className="card-addr">
        <h4 className="add-head">{t("Global headquarters")}</h4>
        <ul>
            <li id="addr">
              <Link to={`/`}>
                <span className="list-text">
                  M2ComSys
                  <br /> 2225 Village Walk Drive
                  <br/> Suite 200 Henderson
                  <br />Nevada 89052, USA
                </span>
              </Link>
            </li>
            <li id="mail">
              <Link to={`/`}>
                <span className="list-text">m2info@m2comsys.us</span>
              </Link>
            </li>
            <li id="phone">
              <Link to={`/`}>
                <span className="list-text">
                  +1-702-733-8781 , +1-866-733-8781{" "}
                </span>
              </Link>
            </li>
          </ul>
        </div> */}
    </div>
  );
};

export default Addr;
